<div class="bg-surface p-8 rounded-2xl border border-line flex flex-col items-center text-center gap-2">
	<mat-icon class="!w-8 !h-8 !text-3xl text-negative">error_outline</mat-icon>
	@if (error.kind === 'forbidden') {
	<p class="body-sm text-ink font-medium max-w-sm">{{ 'ANALYTICS_STATE.FORBIDDEN' | translate }}</p>
	} @else if (error.kind === 'badRequest') {
	<p class="body-sm text-ink font-medium max-w-sm">{{ error.message }}</p>
	} @else {
	<p class="body-sm text-ink font-medium">{{ 'ANALYTICS_STATE.ERROR' | translate }}</p>
	<button
		type="button"
		(click)="retry.emit()"
		class="h-9 px-4 bg-blue hover:bg-blue-hover text-on-blue font-medium rounded-full text-xs transition-colors cursor-pointer">
		{{ 'ANALYTICS_STATE.RETRY' | translate }}
	</button>
	}
</div>
